import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "text-truncate" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PreviewLink = _resolveComponent("PreviewLink")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_VZDeleteModal = _resolveComponent("VZDeleteModal")!
  const _component_SiteDetailModal = _resolveComponent("SiteDetailModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Datatable, {
      "table-data": _ctx.tableData,
      "table-header": _ctx.tableHeader,
      total: _ctx.total,
      rowsPerPage: _ctx.rowsPerPage,
      page: _ctx.page,
      loading: _ctx.loading,
      showSearch: _ctx.showSearch,
      bulkDelete: _ctx.bulkDelete,
      tableForm: _ctx.formData,
      "onUpdate:tableForm": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData) = $event)),
      addButtonText: `${_ctx.t('pages.site.assignSite')}`,
      viewName: _ctx.viewName,
      onQueryUpdate: _ctx.syncQuery,
      onFormSubmit: _ctx.submit,
      onBulkDelete: _ctx.onBulkDelete,
      permissions: _ctx.permissionModel,
      ref: "Datatable"
    }, {
      "cell-siteName": _withCtx(({ row: site }) => [
        _createTextVNode(_toDisplayString(site.siteName) + " ", 1),
        _createVNode(_component_PreviewLink, {
          onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
          routerName: {
          name: 'detail.site',
          params: { id: site.siteId },
        }
        }, null, 8, ["routerName"])
      ]),
      "cell-createdBy": _withCtx(({ row: site }) => [
        _createElementVNode("span", _hoisted_1, _toDisplayString(site.createdBy), 1)
      ]),
      "cell-actions": _withCtx(({ row: site }) => [
        (_ctx.hasPermission(_ctx.permissionModel.delete))
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              onClick: _withModifiers(
          () => {
            _ctx.showDeleteDialog = true;
            _ctx.selectedForAction = site;
          }
        , ["stop"]),
              class: "btn btn-icon btn-danger btn-circle btn-sm ms-3"
            }, _hoisted_4, 8, _hoisted_2))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["table-data", "table-header", "total", "rowsPerPage", "page", "loading", "showSearch", "bulkDelete", "tableForm", "addButtonText", "viewName", "onQueryUpdate", "onFormSubmit", "onBulkDelete", "permissions"]),
    _createVNode(_component_VZDeleteModal, {
      viewName: _ctx.viewName,
      showDialog: _ctx.showDeleteDialog,
      selectedForAction: [_ctx.selectedForAction.webId],
      deleteText: `${_ctx.t('validation.sureToDelete')} ${
      _ctx.selectedForAction.siteName
    }?`,
      onClose: _ctx.refreshList,
      onBulkDelete: _ctx.onBulkDelete
    }, null, 8, ["viewName", "showDialog", "selectedForAction", "deleteText", "onClose", "onBulkDelete"]),
    _createVNode(_component_SiteDetailModal, {
      viewName: "site_location_detail_modal",
      data: _ctx.selectedSite,
      loading: _ctx.loadingSiteDetailModal,
      showDialog: _ctx.showDetailDialog,
      onCloseDetail: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showDetailDialog = false))
    }, null, 8, ["data", "loading", "showDialog"])
  ], 64))
}